import { render } from "./player.vue?vue&type=template&id=d0dbea6a"
import script from "./player.vue?vue&type=script&lang=js"
export * from "./player.vue?vue&type=script&lang=js"

import "./player.vue?vue&type=style&index=0&id=d0dbea6a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__